"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetVouchersCount200ResponseDataToJSON = exports.GetVouchersCount200ResponseDataFromJSONTyped = exports.GetVouchersCount200ResponseDataFromJSON = exports.instanceOfGetVouchersCount200ResponseData = void 0;
/**
 * Check if a given object implements the GetVouchersCount200ResponseData interface.
 */
function instanceOfGetVouchersCount200ResponseData(value) {
    var isInstance = true;
    isInstance = isInstance && "count" in value;
    return isInstance;
}
exports.instanceOfGetVouchersCount200ResponseData = instanceOfGetVouchersCount200ResponseData;
function GetVouchersCount200ResponseDataFromJSON(json) {
    return GetVouchersCount200ResponseDataFromJSONTyped(json, false);
}
exports.GetVouchersCount200ResponseDataFromJSON = GetVouchersCount200ResponseDataFromJSON;
function GetVouchersCount200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': json['count'],
    };
}
exports.GetVouchersCount200ResponseDataFromJSONTyped = GetVouchersCount200ResponseDataFromJSONTyped;
function GetVouchersCount200ResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'count': value.count,
    };
}
exports.GetVouchersCount200ResponseDataToJSON = GetVouchersCount200ResponseDataToJSON;
